export const version = '2.15.5';
//# sourceMappingURL=version.js.map